const placeTextAds = (storyCards, isDesktop) => {
  let index = 0;
  let wordCount = 0;
  const updatedStoryCards = [];
  const wordLimit = 100;

  const getWordCount = (htmlString) => {
    const regex = /(<([^>]+)>)/gi;
    const result = htmlString.replace(regex, "");
    return (result.match(/\b[$]?[\w.-]+\b/g) || []).length;
  };

  const splitHtmlByTags = (htmlString) => {
    const tagBlocks = [];
    const regex = /(<([^>\s]+)(?:\s[^>]*)?>.*?<\/\2>|<[^>\s]+(?:\s[^>]*)?\/?>)/gi;
    let match;
    while ((match = regex.exec(htmlString)) !== null) {
      tagBlocks.push(match[0]);
    }
    return tagBlocks;
  };

  for (const card of storyCards) {
    const updatedCardElements = [];
    for (const element of card["story-elements"]) {
      if (element.type === "text" && element?.text && !element.subtype) {
        const paragraphs = splitHtmlByTags(element.text);
        let updatedText = "";

        for (const paragraph of paragraphs) {
          const paragraphWordCount = getWordCount(paragraph);
          wordCount += paragraphWordCount;

          updatedText += paragraph;

          if (wordCount >= wordLimit) {
            updatedText += `<p>${JSON.stringify({ flag: "ad_goes_here", index })}</p>`;
            index++;
            wordCount = 0;
          }
        }

        updatedCardElements.push({ ...element, text: updatedText });
      } else if (element.subtype === "summary") {
        wordCount += 0;
        updatedCardElements.push(element);
      } else {
        wordCount += 30;
        updatedCardElements.push(element);

        if (wordCount >= wordLimit) {
          updatedCardElements.push({ type: "ad", subtype: "ad", adIndexNo: index });
          index++;
          wordCount = 0;
        }
      }
    }

    updatedStoryCards.push({
      ...card,
      "story-elements": updatedCardElements,
    });
  }

  return updatedStoryCards;
};

const placeMagazineAds = (storyCards, isDesktop, member) => {
  /*if (member && member?.id) {
    return placeTextAds(storyCards, isDesktop);
  }
  return storyCards;*/
  return placeTextAds(storyCards, isDesktop);
};

export const modifyStory = (story, isDesktop, member) => {
  const adsPlacementWrapper = {
    text: placeTextAds,
    magazine: placeMagazineAds,
    sponsored: placeTextAds,
    default: placeTextAds,
  };
  const newCards = (adsPlacementWrapper[story["story-template"]] || adsPlacementWrapper.default)(
    story.cards,
    isDesktop,
    member
  );
  return { ...story, cards: newCards };
};
